import React from 'react';
import styled from 'styled-components/macro';
import { useMessageGetter } from 'react-message-context';
import { TextButton } from '../Text';

const ToggleTextButton = styled(TextButton)`
  position: absolute;
  right: 20px;
  top: -29px;
  text-decoration: none;
  font-size: 14px;
`;

interface TogglePasswordButtonProps {
  showPassword: boolean;
  setShowPassword: (value: boolean) => void;
}

const TogglePasswordButton = ({ showPassword, setShowPassword }: TogglePasswordButtonProps) => {
  const t = useMessageGetter('');

  return (
    <ToggleTextButton type="button" onClick={() => setShowPassword(!showPassword)}>
      {showPassword ? t('input.hidePassword') : t('input.showPassword')}
    </ToggleTextButton>
  );
};

export default TogglePasswordButton;
